export const API_PREVIEW = "/api/preview";
export const API_EXIT_PREVIEW = "/api/exit-preview";
